import React from 'react';
import PropTypes from 'prop-types';
import {Box, Container, Heading, Skeleton, Text} from '@tenancy.nz/ui';

const TITLE = 'These properties are managed by:';

function Nameplate({
  heading = '',
  logo = '',
  skeleton = false,
  ctaLabel = '',
  ctaHref = '',
}) {
  return (
    <Box
      sx={{
        borderBottom: '1px solid',
        borderColor: 'grey.300',
        bgcolor: 'common.white',
      }}>
      <Container maxWidth="lg" sx={{py: 5}}>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 8}}>
          <Box
            sx={{
              flexShrink: 0,
              width: 56,
              height: 56,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            {skeleton ? (
              <Skeleton variant="rectangular" width={56} height={56} />
            ) : (
              logo && (
                <Box
                  component="img"
                  src={logo}
                  alt={typeof heading === 'string' ? heading : ''}
                  sx={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                  }}
                />
              )
            )}
          </Box>
          <Box sx={{flex: 1, minWidth: 0}}>
            {skeleton ? (
              <>
                <Skeleton width="40%" height={20} />
                <Skeleton width="30%" height={24} />
              </>
            ) : (
              <>
                <Text
                  sx={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: 'grey.600',
                    m: 0,
                    lineHeight: '18.667px',
                  }}>
                  {TITLE}
                </Text>
                <Heading
                  as="h3"
                  sx={{
                    fontSize: '21.333px',
                    fontWeight: 600,
                    lineHeight: '20px',
                    mt: '5.573px',
                  }}>
                  {heading}
                </Heading>
              </>
            )}
          </Box>
          {!skeleton && ctaLabel && ctaHref && (
            <Box
              component="a"
              href={ctaHref}
              sx={{
                flexShrink: 0,
                display: {xs: 'none', sm: 'flex'},
                alignItems: 'center',
                justifyContent: 'center',
                height: 48,
                px: 6,
                borderRadius: '4px',
                border: '1px solid',
                borderColor: 'primary.main',
                bgcolor: 'common.white',
                color: 'primary.main',
                textDecoration: 'none',
                fontWeight: 700,
                fontSize: 16,
                lineHeight: '18px',
                transition: 'background-color 0.15s ease-out',
                '&:hover': {
                  bgcolor: 'primary.main',
                  color: 'common.white',
                },
              }}>
              {ctaLabel}
            </Box>
          )}
        </Box>
      </Container>
    </Box>
  );
}

Nameplate.propTypes = {
  heading: PropTypes.node,
  logo: PropTypes.string,
  skeleton: PropTypes.bool,
  ctaLabel: PropTypes.string,
  ctaHref: PropTypes.string,
};

export default Nameplate;
